<section id="funciona">
  <div class="process-container">

    <img class="green-lines" src="{{ images.greenLines }}" alt="">

    <div>
      <span>Conoce nuestro</span>
      <span> proceso</span>
    </div>

    <div class="process-animation-container">
      <div class="animation">
        <div class="hero-animation">
          <ng-lottie
            [options]="loaderPerfilador[0]"
             [ngStyle]="{
              display: 'inherit',
              justifyContent: 'center',
              alignItems: 'center',
              width: '150px',
              height: '150px',
              objectFit: 'contain',
              marginBottom: '10px'
            }"
            #lott>
          </ng-lottie>
        </div>
        <p class="animation-description">Haz una simulación de tu crédito</p>
      </div>
      <div class="animation">
        <div class="hero-animation">
          <ng-lottie
            [options]="loaderPerfilador[1]"
            [ngStyle]="{
              display: 'inherit',
              justifyContent: 'center',
              alignItems: 'center',
              width: '150px',
              height: '150px',
              objectFit: 'contain',
              marginBottom: '10px'
            }"
            #lott>
          </ng-lottie>
        </div>
        <p class="animation-description">Llena tu solicitud y valida tu identidad*</p>
      </div>
      <div class="animation">
        <div class="hero-animation">
          <ng-lottie
            [options]="loaderPerfilador[2]"
             [ngStyle]="{
              display: 'inherit',
              justifyContent: 'center',
              alignItems: 'center',
              width: '150px',
              height: '150px',
              objectFit: 'contain',
              marginBottom: '10px'
            }"
            #lott>
          </ng-lottie>
        </div>
        <p class="animation-description">Analizaremos tu empresa</p>
      </div>
      <div class="animation">
        <div class="hero-animation">
          <ng-lottie
            [options]="loaderPerfilador[3]"
             [ngStyle]="{
              display: 'inherit',
              justifyContent: 'center',
              alignItems: 'center',
              width: '150px',
              height: '150px',
              objectFit: 'contain',
              marginBottom: '10px'
            }"
            #lott>
          </ng-lottie>
        </div>
        <p class="animation-description">Carga los documentos de tu empresa</p>
      </div>
      <div class="animation">
        <div class="hero-animation">
          <ng-lottie
            [options]="loaderPerfilador[4]"
             [ngStyle]="{
              display: 'inherit',
              justifyContent: 'center',
              alignItems: 'center',
              width: '150px',
              height: '150px',
              objectFit: 'contain',
              marginBottom: '10px'
            }"
            #lott>
          </ng-lottie>
        </div>
        <p class="animation-description">Recibe el crédito en la cuenta de tu empresa</p>
      </div>
    </div>

    <div>
      <p class="process-footer">*Solo el representante legal de la empresa puede solicitar un préstamo</p>
    </div>

  </div>
</section>
